<template>
  <div id="promotions-list">
    <table class="table" v-if="$store.state.responsive.viewDesktopLists">
      <thead class="fixheader">
        <tr>
          <th class="align-middle">
            <ThOrder :textHeader="'Nombre de promoción'" :idHeader="'name'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Id de promoción'" :idHeader="'id'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Fecha de inicio'" :idHeader="'startDate'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Fecha de fin'" :idHeader="'endDate'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Tenant'" :idHeader="'tenant'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Canal'" :idHeader="'channel'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Limite de unidades'" :idHeader="'units_limit'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle">
            <ThOrder :textHeader="'Estado'" :idHeader="'status'" :currentOrderBy="currentOrderBy"
              @selectOrder="selectOrder($event)"></ThOrder>
          </th>
          <th class="align-middle thOperaciones"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(promotion, index) in promotionsAux" v-bind:key="index">
          <td class="align-middle py-4">{{ promotion.name }}</td>
          <td class="align-middle py-4">{{ promotion.promotionId }}</td>
          <td class="align-middle py-4">{{ promotion.start_date }}</td>
          <td class="align-middle py-4">{{ promotion.end_date }}</td>
          <td class="align-middle py-4">
            <template v-for="(tenant, index) in promotion.tenant">
              {{ tenant.toUpperCase() }}{{ index &lt; promotion.tenant.length - 1 ? ', ' : '' }}
            </template>
          </td>
          <td class="align-middle py-4">
            <template v-for="(channel, index) in promotion.channel">
            {{ channel.toUpperCase() }}{{ index &lt; promotion.channel.length - 1 ? ', ' : '' }}
          </template></td>
          <td class="align-middle py-4">{{ promotion.units_limit }}</td>
          <td class="align-middle py-4">
            <span v-if="promotion.status === 'ACTIVATED'"
                class="badge text-success border border-success">{{ getTitle(promotion.status) }}</span>
            <span v-else-if="promotion.status === 'PENDING'"
                class="badge text-info border border-info">{{ getTitle(promotion.status) }}</span>
            <span v-else-if="promotion.status === 'DEACTIVATED' || promotion.status === 'DELETED'"
                class="badge text-danger border border-danger">{{ getTitle(promotion.status) }}</span>
            <span v-else class="badge text border">{{ getTitle(promotion.status) }}</span>
          </td>
          <td id="operaciones" class="align-middle py-4 tdOperaciones">
            <div class="dropdown dropdown-inherit">
              <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <v-icon name="fa-ellipsis-v" />
              </span>
              <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                <a class="dropdown-item py-3 px-4" href="#" data-toggle="modal"
                  @click="showDetails(promotion)">Ver Detalles</a>
                <a v-if="promotion.status === 'PENDING' || (promotion.status === 'DEACTIVATED' && verifyDate(promotion.end_date))" class="dropdown-item py-3 px-4" href="#"
                  @click="showModalAction(promotion,'ACTIVAR')">Activar</a>
                <a v-if="promotion.status === 'PENDING'" class="dropdown-item py-3 px-4" href="#"
                  @click="showModalAction(promotion,'ELIMINAR')">Eliminar</a>
                <a v-if="promotion.status === 'ACTIVATED'" class="dropdown-item py-3 px-4" href="#"
                  @click="showModalAction(promotion,'DESACTIVAR')">Desactivar</a>
                <a v-if="$store.state.roles.Backoffice_Superadmin" class="dropdown-item py-3 px-4" href="#"
                  @click="createPromotionWith($event,promotion.promotionId)">Crear promoción desde esta</a>
                <a v-if="$store.state.roles.Backoffice_Superadmin" href="#" class="dropdown-item py-3 px-4" @click="openEditModal(promotion)">Editar Promoción</a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <template v-if="!$store.state.responsive.viewDesktopLists">
      <div class="card p-2 mb-3" v-for="(promotion, index) in promotionsAux" v-bind:key="index">
        <div class="list-item">
          <div class="item d-flex align-items-center justify-content-between px-2 py-3" data-toggle="collapse"
            :href="'#collapseExample' + index" role="button" aria-expanded="true"
            :aria-controls="'collapseExample' + index">
            <h4 class="m-0">{{ promotion.name }}</h4>
            <v-icon name="bi-chevron-up" />
          </div>
          <div class="collapse show ml-3 mr-2 borderFirstItem" :id="'collapseExample' + index">
            <div class="d-flex align-items-center justify-content-between flex-wrap mb-2 mt-2">
              <div class="d-flex align-items-center justify-content-start">
                <p class="m-0 mr-2"><strong>Id de promoción: </strong>{{ promotion.promotionId }}</p>
              </div>
              <div>
                <div class="dropdown dropdown-inherit">
                  <span id="dropdownOperations" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <v-icon name="fa-ellipsis-v" />
                  </span>
                  <div class="dropdown-menu p-0 dropdown-menu-right" aria-labelledby="dropdownOperations">
                    <a class="dropdown-item py-3 px-4" href="#" data-toggle="modal"
                      @click="showDetails(promotion)">Ver Detalles</a>
                    <a v-if="promotion.status === 'PENDING' || (promotion.status === 'DEACTIVATED' && verifyDate(promotion.end_date))" class="dropdown-item py-3 px-4" href="#"
                      @click="showModalAction(promotion,'ACTIVAR')">Activar</a>
                    <a v-if="promotion.status === 'PENDING'" class="dropdown-item py-3 px-4" href="#"
                      @click="showModalAction(promotion,'ELIMINAR')">Eliminar</a>
                    <a v-if="promotion.status === 'ACTIVATED'" class="dropdown-item py-3 px-4" href="#"
                      @click="showModalAction(promotion,'DESACTIVAR')">Desactivar</a>
                    <a v-if="$store.state.roles.Backoffice_Superadmin" class="dropdown-item py-3 px-4" href="#"
                      @click="createPromotionWith($event,promotion.promotionId)">Crear promoción desde esta</a>
                    <a v-if="$store.state.roles.Backoffice_Superadmin" href="#" class="dropdown-item py-3 px-4" @click="openEditModal(promotion)">Editar Promoción</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Fecha de inicio: </strong>{{ promotion.start_date }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Fecha de fin: </strong>{{ promotion.end_date }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Tenant: </strong></p>
              <template v-for="(tenant, index) in promotion.tenant">
                {{ tenant.toUpperCase() }}{{ index === (promotion.tenant.length - 1) ? '' : ', ' }}
              </template>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Canal: </strong></p>
              <template v-for="(channel, index) in promotion.channel">
                {{ channel.toUpperCase() }}{{ index === (promotion.channel.length - 1) ? '' : ', ' }}
              </template>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Limite de unidades: </strong> {{ promotion.units_limit }}</p>
            </div>
            <div class="d-flex align-items-center justify-content-start flex-wrap mb-2">
              <p class="m-0 mr-2"><strong>Estado: </strong></p>
              <span v-if="promotion.status === 'ACTIVATED'"
                class="badge text-success border border-success">{{ getTitle(promotion.status) }}</span>
              <span v-else-if="promotion.status === 'PENDING'"
                  class="badge text-info border border-info">{{ getTitle(promotion.status) }}</span>
              <span v-else-if="promotion.status === 'DEACTIVATED' || promotion.status === 'DELETED'"
                  class="badge text-danger border border-danger">{{ getTitle(promotion.status) }}</span>
              <span v-else class="badge text border">{{ getTitle(promotion.status) }}</span>
            </div>
          </div>
        </div>
      </div>
    </template>
    <PromotionDetail v-if="showModalDetails" :promotion="promotion" :id="'showPromotionDetails'" :modalTitle="'DETALLE PROMOCIÓN'" :class="'modal-xl'" @closeModal="showModalDetails = false" />
    <ModalActions v-if="showModalActions" :promotion="promotion" :action="action" :id="'showModalActions'" :modalTitle="'PROMOCIÓN'" :class="'modal'" @aceptarAction="refreshRegisterList" @closeModal="showModalActions = false" />
    <EditPromotionModal
        ref="editPromotionModal"
        v-show="showEditModal"
    :id="'editPromotionModal-' + (selectedPromotion ? selectedPromotion.promotionId : 'default')"
    :promotion="selectedPromotion || {}"
    @closeModal="showEditModal = false"
    @promotionUpdated="handlePromotionUpdated"
    />
  </div>
</template>

<script>
import ThOrder from '../../../Shared/ThOrder.vue';
import PromotionDetail from './PromotionDetail.vue';
import ModalActions from './ModalActions.vue';
import { Modal as ModalBootstrap } from "bootstrap";
import EditPromotionModal from "./EditPromotionModal.vue";
export default {
  name: 'promotionsList',
  props: [
    'promotions',
  ],
  data() {
    return {
      currentOrder: '',
      currentOrderBy: '',
      promotionsAux: [],
      promotionNameCheck: '',
      showModalDetails: false,
      promotion: null,
      action: '',
      showModalActions: false,
      showEditModal: false,
      selectedPromotion: null,

    };
  },
  updated() {
    this.promotionsAux = this.promotions
  },
  components: {
    ThOrder,
    PromotionDetail,
    ModalActions,
    EditPromotionModal,
  },

  watch: {
    promotions: {
      immediate: true,
      handler(newPromotions) {
        this.promotionsAux = [...newPromotions];
      },
    },
  },
  methods: {
    selectOrder({ orderBy, order }) {
      this.currentOrder = order;
      this.currentOrderBy = orderBy;
      this.promotionsAux = [...this.promotionsAux].sort((a, b) => {
        let valueA = a[orderBy] || "";
        let valueB = b[orderBy] || "";
        if (valueA < valueB) return order === "ASC" ? -1 : 1;
        if (valueA > valueB) return order === "ASC" ? 1 : -1;
        return 0;
      });
    },
    handlePromotionUpdated(updatedPromotion) {
      const index = this.promotionsAux.findIndex(
          (p) => p.promotionId === updatedPromotion.promotionId
      );

      if (index !== -1) {

        this.promotionsAux[index] = {
          ...this.promotionsAux[index],
          ...updatedPromotion,
        };
      } else {
        console.warn("La promoción actualizada no se encontró en la lista.");
      }

      if (!updatedPromotion.id) {
        console.warn(
            "Datos incompletos devueltos por el servidor. Sincronizando con el servidor..."
        );
        this.refreshRegisterList();
      }
    },
    refreshRegisterList() {
      this.$emit("sendRefreshRegisterList");
    },
    showDetails(promotion) {
      if (promotion.criteria.parameters) {
        const modifiedPromotion = JSON.parse(JSON.stringify(promotion));
        for (const [key, value] of Object.entries(modifiedPromotion.criteria.parameters)) {
          modifiedPromotion.criteria.condition = modifiedPromotion.criteria.condition.replace(key, value);
        }
        this.promotion = modifiedPromotion;
      } else {
        this.promotion = promotion;
      }
      this.showModalDetails = true;
      this.$nextTick(() => {
        const myModal = new ModalBootstrap(document.getElementById('showPromotionDetails'));
        myModal.show();
      });
    },

    showModalAction(promotion, action) {
      this.promotion = promotion;
      this.action = action;
      this.showModalActions = true;
      this.$nextTick(() => {
        const myModal = new ModalBootstrap(document.getElementById('showModalActions'));
        myModal.show();
      });
    },
    openEditModal(promotion) {
      if (!promotion) {
        console.error("No se proporcionó promoción para editar");
        return;
      }
      this.selectedPromotion = promotion; // Asegura que los datos son válidos.
      this.showEditModal = true;

      this.$nextTick(() => {
        const modal = this.$refs.editPromotionModal;
        if (modal && modal.show) {
          modal.show(); // Abre el modal
        } else {
          console.error("No se encontró el método 'show' en el modal.");
        }
      });
    },

    getTitle(title) {
      switch (title) {
        case 'ACTIVATED':
          return 'ACTIVO';
        case 'PENDING':
          return 'PENDIENTE';
        case 'DEACTIVATED':
          return 'DESACTIVADO';
        case 'DELETED':
          return 'ELIMINADO';
        default:
          return title;
      }
    },
    verifyDate(end_date){
      const currentDate = new Date();
      const endDate = new Date(end_date);
      return currentDate <= endDate;
    },
    createPromotionWith(e,idPromotion){
      e.preventDefault();
      const query = { idPromotion };
      this.$router.push({ name: 'newPromotionStep1', query });
    },


  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#operaciones {
  text-align: right;
}

thead {
  background-color: rgb(250, 250, 250);
}

.col-12 {
  padding: 0%;
}
</style>
